import React, { useState, useEffect } from "react";
import { Box, Chip, MenuItem, Select } from "@mui/material";

const MemberType = ({
  getData,
  setVesselId,
  vesselData,
  vesselId,
  width,
  setPage,
}) => {
  //   const [options, setOption] = useState();
  const [selectedValue, setSelectedValue] = useState(vesselId);

  useEffect(() => {
    getData(1);
    setPage(1);
  }, [selectedValue]);
  return (
    <Select
      style={{ width: width || "22%", height: "40px", marginRight: "10px" }}
      required
      displayEmpty
      renderValue={vesselId !== "" ? undefined : () => "Select Type"}
      value={selectedValue}
      onChange={(e) => {
        setVesselId(e.target.value);
        setSelectedValue(e.target.value);
      }}
    >
      <MenuItem value={"member"}>Member</MenuItem>
    </Select>
  );
};

export default MemberType;
